export const hasSimulacionResultado = (state) =>
   Array.isArray(state.simulacionResultado) &&
   state.simulacionResultado.length > 0;
